// Has to be here because poopover, sorry
:root {
    --off-black: #0f0f0f;
}

.field {
    --invalid: oklch(62% 0.2856 29.23deg);
    --xcient-gradient-deg: 258deg;

    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);

    :global(.react-aria-Label) {
        color: var(--blue);
        font: var(--font-label);
    }

    [slot="errorMessage"] {
        color: var(--invalid);
    }
}

.input {
    composes: outline from "../../../styles/composable/utility.module.css";
}

.textField {
    composes: field;

    input {
        width: 100%;
        background-color: var(--off-black);
        box-shadow: none;
        border: none;
        padding: var(--spacer-16);
        color: var(--color-text-primary);
        font: var(--font-p-16);
    }

    div:has(> input) {
        padding-bottom: 1px;
        background: var(--xcient-gradient);
    }

    &[data-invalid="true"] {
        div:has(> input) {
            background: var(--invalid);
        }
    }
}

.boxWrapper {
    display: inline-flex;
    align-items: center;
}

.checkbox {
    composes: input;
    display: inline-block;
    width: var(--spacer-24);
    height: var(--spacer-24);
    border: 1px solid var(--color-text-primary);

    [data-selected="true"] > & {
        background-color: var(--color-text-primary);
    }

    &:has(+ *) {
        margin-right: 0.5em;
    }
}

.checkboxGroup {
    composes: field;
    gap: var(--spacer-16);

    [slot="description"] {
        font: var(--font-fineprint);
    }
}

.radioGroup {
    composes: checkboxGroup;
}

.radio {
    composes: input;
    align-items: center;
    width: var(--spacer-24);
    height: var(--spacer-24);
    border: 1px solid var(--color-contrast);
    border-radius: 50%;
    position: relative;

    [data-selected="true"] > &::after {
        content: "";
        background: var(--color-text-primary);
        border-radius: 50%;
        position: absolute;
        inset: 25%;
    }

    &:has(+ *) {
        margin-right: 0.5em;
    }
}

.dropdown {
    composes: field;

    div:has(> [aria-haspopup="listbox"]) {
        padding-bottom: 1px;
        background: var(--xcient-gradient);
    }

    &[data-open="true"] {
        div:has(> [aria-haspopup="listbox"]) {
            background: transparent;
        }
    }

    svg {
        width: var(--spacer-24);
        height: var(--spacer-24);
        stroke: currentColor;
        fill: currentColor;
    }
}

.dropdownTrigger {
    composes: buttonReset from "../../../styles/composable/utility.module.css";
    composes: input;
    background-color: var(--off-black);
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacer-16);
}

.dropdownPopover {
    composes: match from "../../../styles/theming.module.css";
    width: var(--trigger-width);
    overflow-y: auto;

    [role="option"] {
        --padding: var(--spacer-16);

        background-color: var(--off-black);
        color: var(--color-text-primary);
        padding-inline: var(--padding);

        & > span {
            display: block;
            padding-block: var(--padding);
            border-top: 1px solid #606060;
        }

        &[data-selected="true"] {
            background-color: #404040;

            & > span {
                border-top: none;
            }

            & + [role="option"] > span {
                border-top: none;
            }
        }
    }
}

.fullWidth {
    grid-column: 1 / -1;
    margin-block: var(--spacer-40);
}
